 /**
  * @name ONE_KU_PRICE_LIST - 1ku price list
  * @constant
  * @string
  * @description The value of the description identifier in the parameters
  */
export const ONE_KU_PRICE_LIST = '2892';

/**
 * @name CLASS_DRAGGABLE
 * @constant
 * @description CSS classname for draggable parameters
 */
 export const CLASS_DRAGGABLE = 'draggable';

 /**
  * @name DESCRIPTION
  * @constant
  * @string
  * @description The value of the description identifier in the parameters
  */
 export const DESCRIPTION = '3040';
 
 /**
  * @name EVALUATION_BOARD
  * @constant
  * @string
  * @description The value of evaluation board
  */
 export const EVALUATION_BOARD = 'Evaluation board';
 
 /**
  * @name HARDWARE
  * @constant
  * @string
  * @description The value of the hardware identifier in the parameters
  */
 export const HARDWARE = '3042';
 
 /**
  * @name INVENTORY
  * @constant
  * @string
  * @description The value of the inventory identifier in the parameters
  */
  export const INVENTORY = '2904';
 
 /**
  * @name NEWEST
  * @constant
  * @string
  * @description 
  */
 export const NEWEST = 'Newest';

  /**
  * @name OLDEST
  * @constant
  * @string
  * @description 
  */
   export const OLDEST = 'Oldest';
 
 /**
  * @name NEW
  * @constant
  * @string
  * @description Value of a part when it is not new
  */
 export const NEW = 'Yes';
 
 /**
  * @name PART_META
  * @constant
  * @string
  * @description The value of the part meta info (model, generic, datasheet, etc.) identifier in the parameters
  */
 export const PART_META = '0';
 
 /**
  * @name PART_NUMBER
  * @constant
  * @string
  * @description part number display Name for download to excel 
  */
 export const PART_NUMBER = 'Part #';
 
 /**
  * @name PUBLISH_DATE
  * @constant
  * @string
  * @description The value of the publish date identifier in the parameters
  */
 export const PUBLISH_DATE = '2902';

/**
  * @name PUBLISH_DATE
  * @constant
  * @string
  * @description The value of the publish date identifier in the parameters
  */
 export const THUMBNAIL = '3043';
 
 /**
  * @name REFERENCE_CIRCUIT
  * @constant
  * @string
  * @description The value of evaluation board
  */
 export const REFERENCE_CIRCUIT = 'Reference circuit';
 
 /**
  * @name STATUS
  * @constant
  * @string
  * @description The value of the status identifier in the parameters
  */
 export const STATUS = '793';
 
 /**
  * @name TOOLS
  * @constant
  * @string
  * @description The value of the tools identifier in the parameters
  */
 export const TOOLS = '2825';
 
 /**
  * @name VINTAGE
  * @constant
  * @string
  * @description The value of the vintage identifier in the parameters
  */
 export const VINTAGE = 's1';

  /**
 * @name SORT_BY_DATE
 * @constant
 * @string
 * @description The value of the vintage identifier in the parameters
 */
export const SORT_BY_DATE = '805';